// extracted by mini-css-extract-plugin
module.exports = {"blogListTitle":"style-module--blogListTitle--1rnTu","blogListDate":"style-module--blogListDate--17kPA"};